import { themedStyled } from 'common/styles/styletron.theme';

export const DrawerBody = themedStyled('div', {
  margin: '20px',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
});

export const DrawerFooter = themedStyled('div', {
  padding: '20px',
  display: 'flex',
  width: '100%',
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: 'white',
  justifyContent: 'space-between',
  boxShadow: '0px 0 2px rgba(0, 0, 0, 0.4)',
  zIndex: 90,
});

export const DrawerHeaderContainer = themedStyled('div', ({ $theme }) => ({
  padding: '20px',
  // backgroundColor: $theme.colors.skyLighter,
  display: 'flex',
  justifyContent: 'space-between',
}));

export const DrawerLeftContainer = themedStyled('div', ({ $theme }) => ({}));

export const DrawerRightContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
}));
